
import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';

@MergeSchema({
    entity: ActivityEntityName.Site
})
export class JobSiteMergeData {

    @MergeField()
    street: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    contactName: string;

    @MergeField(
        {
            displayName: "Contact Phone (Deprecated: use contactHomePhone)"
        }
    )
    contactPhone: string;

    @MergeField()
    contactMobile: string;

    @MergeField()
    contactHomePhone: string;

    @MergeField()
    contactWorkPhone: string;

    @MergeField()
    contactEmail: string;

    @MergeField()
    name: string;

    @MergeField()
    country: string;

    @MergeField()
    county: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    placeId: string;

    siteId: string;
    customFields: any;
}

export const JobSiteMergeSchema = getSchema(JobSiteMergeData);